import api from "../api/facilities";
import {logSuccess, logError, createError} from "../../ui/Notify";
import types from "./types";
import {getFacility, getFacilities} from "./actions";

  function deleteFacilitiesRequest() {
    return {
      type: types.DELETE_FACILITIES_REQUEST,
      isDeletingFacilities: true
    };
  }

  function deleteFacilitiesCompleted(deletedFacilities) {
    return {
      type: types.DELETE_FACILITIES_COMPLETED,
      isDeletingFacilities: false,
      deletedFacilities
    };
  }

  function deleteFacilitiesError(deletingFacilitiesError) {
    return {
      type: types.DELETE_FACILITIES_ERROR,
      isDeletingFacilities: false,
      deletingFacilitiesError
    };
  }

  function deleteImageRequest() {
    return {
      type: types.DELETE_IMAGE_REQUEST,
      isDeletingImage: true
    };
  }

  function deleteImageCompleted(deletedImage) {
    return {
      type: types.DELETE_IMAGE_COMPLETED,
      isDeletingImage: false,
      deletedImage
    };
  }

  function deleteImageError(imagesError) {
    return {
      type: types.DELETE_IMAGE_ERROR,
      isDeletingImage: false,
      imagesError
    };
  }

  export function deleteFacilities(facilities) {
    return async dispatch => {
      dispatch(deleteFacilitiesRequest());
      const response = await Promise.all(
        facilities.map(id => api.deleteFacility(id))
      );

      if (response.every(({ data }) => data.success == true)) {
        dispatch(deleteFacilitiesCompleted(response));
        dispatch(getFacilities());
      } else {
        dispatch(deleteFacilitiesError(response));
      }
      return response;
    };
  }

  export function deleteImage(fileId) {
    return async (dispatch, getState) => {
      dispatch(deleteImageRequest());
      const id = getState().facilities.facilityFullInfo.info.id;

      return api.deleteFacilityPhoto(id,fileId)
        .then(response => {
          if (response.status === 200) {
            dispatch(deleteImageCompleted(response.data));
            dispatch(getFacility(id));
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            logError(err.response);
            dispatch(deleteImageError(err.response));
          } else {
            logError(err);
            dispatch(deleteImageError(createError("Не удалось отправить запрос удаления фотографии")));
          }
        });
    };
  }

export default {
  deleteFacilities,
  deleteImage
}
